module.exports = __webpack_public_path__ + "img/login_tab03_04.b0b22248.png";